import React from 'react';
import PropTypes from 'prop-types';
import {getWidgetValue} from "sportinglife-react-common/widgets";
import TipsWidget from "../../../Common/components/TipsWidget/TipsWidget";
import withErrorBoundary from "../../../Errors/components/withErrorBoundry";

const TipWidget = ({widget}) => {
  const tipsData = getWidgetValue(widget, "tips");
  return Object.keys(tipsData).length > 0 && <TipsWidget tips={tipsData} />;
};

TipWidget.mapProps = (props) => ({
  widget: props.widget
})
TipWidget.propTypes = {
  widget: PropTypes.object
}

export default withErrorBoundary(TipWidget);



// WEBPACK FOOTER //
// ./modules/News/components/widgets/Tip.widget.js